import { onMounted, computed, watch } from 'vue';
import { $gfLeftSideBar } from '@/app/index';
import { usePlanPermission, FEATURE_TYPES } from '@modules/common';

import type { TElementSidebarEditor } from '../types';
import { useGoToPricing } from './useGoToPricing';
type TSnippetCategoryProps = {
  item: TElementSidebarEditor;
};

export const useSnippet = (props: TSnippetCategoryProps) => {
  const { item } = props;
  const { getPermissionForTypeInfo } = usePlanPermission();
  const { goToPricing } = useGoToPricing();

  const isDisableElement = computed(() => {
    if (item.key === 'popup') {
      return !getPermissionForTypeInfo(FEATURE_TYPES.POPUP_ELEMENT);
    }
    return false;
  });

  onMounted(async () => {
    if (item.key !== 'popup' || !isDisableElement.value) {
      const element = document.getElementById(`snippet-${item.id}`);
      $gfLeftSideBar().data('gfleftsidebar').applyDragForASnippet(element);

      $gfLeftSideBar().data('gfleftsidebar').saveSnippetsData(item.html);
    }
  });

  watch(isDisableElement, (newValue) => {
    if (item.key === 'popup' && !newValue) {
      const element = document.getElementById(`snippet-${item.id}`);
      $gfLeftSideBar().data('gfleftsidebar').applyDragForASnippet(element);
      $gfLeftSideBar().data('gfleftsidebar').saveSnippetsData(item.html);
    }
  });

  const onGoToPricingPage = () => {
    if (isDisableElement.value) {
      goToPricing();
    }
  };

  return { item, isDisableElement, onGoToPricingPage };
};
